/**
 * Documentation spaces of the active project (card 4.3): the list, which page
 * is where, the selected space (remembered per project) and the filter scope
 * the Documents trees read. Under All projects / No project there are no
 * spaces and the filter is the plain project filter.
 */
import { useMemo } from 'react';
import { useProjectFilterScope } from '../../scope/projectMembership';
import { useProjectScopeStore } from '../../scope/projectScopeStore';
import { selectedSpaceOf, spaceAssignment, spacesOf, useDocSpaceSelection } from '../../scope/docSpacesModel';

export default function useDocSpaces() {
  const filter = useProjectFilterScope();
  const docSpaces = useProjectScopeStore((s) => s.known.docSpaces);
  const members = useProjectScopeStore((s) => s.known.docSpaceMembers);
  const byProject = useDocSpaceSelection((s) => s.byProject);
  const select = useDocSpaceSelection((s) => s.select);
  const project = filter.status === 'ready' ? filter.activeProject : null;

  return useMemo(() => {
    if (!project) return { project: null, spaces: [], members, assignment: new Map(), selectedSpaceId: null, select: () => {}, filterScope: filter };
    const spaces = spacesOf(docSpaces, project.id);
    const assignment = spaceAssignment(members, project.id, spaces);
    const selectedSpaceId = selectedSpaceOf(byProject, project.id, spaces);
    return {
      project,
      spaces,
      members,
      assignment,
      selectedSpaceId,
      select: (spaceId) => select(project.id, spaceId),
      filterScope: { ...filter, docSpace: { spaceId: selectedSpaceId, assignment } },
    };
  }, [project, filter, docSpaces, members, byProject, select]);
}
